import React from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../utils/helpers";
import AuthContext from '../../context/AuthContext'

const TotalAcceptedList = ({ allTotalEmployee, getTotalEmployee, handleAcceptedView, user, page, sort, setSort }) => {
  const { t } = useTranslation();
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.Employee?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeEmployeeStatus}/${item?.Employee?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getTotalEmployee();
      }
    } catch (error) {
      console.log("error in get all employee list==>>>>", error.message);
    }
  };

  // Helper function to get sort icon
  const getColumnSortIcon = (backendField) => {
    if (sort.sortBy === backendField) {
      return (
        <span>
          {sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4 ml-1" />}
          {sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180 ml-1" />}
        </span>
      );
    }
    return null;
  };
  const getShortId = (name, id) =>
  `${name?.slice(0, 3) ?? ''}${id?.slice(-3) ?? ''}`

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {t("EMPLOYEE_ID")}
                </div>
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {t("EMPLOYEE_NAME")}
                </div>
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {t("JOB_TITLE")}
                </div>
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {t("DEPARTMENT")}
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  <span>{t("EMAIL_ID")}</span>
                </div>
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {"Employment Status"}
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  // Handle accepted date sort
                  if (sort.sortColumn === 'accepted_date' && sort.sortType === 'asc') {
                    setSort({
                      ...sort,
                      sortBy: 'acceptedRejectedAt',
                      sortType: 'desc',
                    });
                  } else {
                    setSort({
                      ...sort,
                      sortColumn: 'accepted_date',
                      sortBy: 'acceptedRejectedAt',
                      sortType: 'asc',
                    });
                  }
                }}
              >
                <div className="flex items-center">
                  <span>{t("ACCEPTED_DATE")}</span>
                  {getColumnSortIcon("acceptedRejectedAt")}
                </div>
              </th>
              {/* <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th> */}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {allTotalEmployee &&
              allTotalEmployee?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r">{item?.employmentStatus === "terminated" ? getShortId(user?.name, item?.Employee?._id): item?.Employee?.employeeId} </td>
                  <td className="py-4 px-6 border-r">{item?.Employee?.name}</td>
                  <td className="py-4 px-6 border-r text-left">{item?.Job?.name}</td>
                  <td className="py-4 px-6 border-r text-left">{item?.JobDepartment?.name}</td>
                  <td className="py-4 px-6 border-r text-left">{item?.Employee?.email}</td>
                  <td className="py-4 px-6 border-r text-left">{startCase(item?.employmentStatus)}</td>
                  <td className="py-4 px-6 border-r text-left">{dayjs(item?.acceptedRejectedAt).format("MM-DD-YYYY hh:mm A")} </td>

                  {/* <td className="py-4 px-6 border-r text-center">
                    <label className="inline-flex relative items-center cursor-pointer" title={`${item?.Employee?.status === "active" ? "Active" : "Inactive"}`}>
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={item?.Employee?.status === "active"}
                        onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item?.Employee?.name} '?`, item, handelStatusChange)}
                      />
                      <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                    </label>
                  </td> */}
                  <td className="py-4 px-6 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        <li onClick={() => handleAcceptedView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title={t("O_VIEW_USER")}>
                            {" "}
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(allTotalEmployee) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TotalAcceptedList;